module.exports = {
    showStats: false,
    resolution: {width:1024, height:768},
    loadscreen: {
        loadbar:{
            position:{x:110, y:618}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 11
// module chunks = 0